import http from "@/utils/request";
// 获取PartnerAccessToken
export const getPartnerAccessToken = (data) => {
  return http({
    url: `https://atom.musiyoujia.com/member/fankeinsideservice/getPartnerAccessToken`,
    params: data,
  });
};

// 刷新PartnerAccessToekn
export const refreshPartnerAccessToken = (data) => {
  return http({
    url: `https://atom.musiyoujia.com/member/fankeinsideservice/refreshPartnerAccessToken`,
    data,
  });
};

// 获取凡科活动详情
export const getFankeactivityDetail = (data) => {
  return http({
    url: `https://atom.musiyoujia.com/member/fankeactivity/get`,
    data,
  });
};
